import styled from "styled-components";
import Switch from "rc-switch";

export const MediaAssetsWrapper = styled.aside`
  display: flex;
  flex-direction: column;
  gap: 10px;
  position: fixed;
  right: 20px;
  top: 125px;
  padding-top: 25px;
  padding-left: 18px;
  width: 353px;
  height: 100%;
  border-left: ${({ theme }) =>
    `1px solid ${theme.colors.campaignMediaAssets.containerBorderColor}`};
`;

export const AssetAttentionBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.campaignMediaAssets.attentionBoxLogoBgColor};
  color: ${({ theme }) => theme.colors.campaignMediaAssets.attentionBoxLogoTextColor};
  padding: 15px 14.6px 13px 20px;
  border-radius: 8px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  margin: 7px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
`;

export const ToggleWrapper = styled.div`
  display: flex;
  margin-top: 15px;
  gap: 10px;
  align-items: center;
  font-size: 12px;
  font-weight: 500;
`;

export const Toggle = styled(Switch)`
  background-color: ${({ defaultTalentbaitLogo }) => (defaultTalentbaitLogo ? "#FFDD7B" : "#ccc")};
  border-color: transparent;
`;
